@if (!fullscreenService.isFullscreenImageActive) {
  <mat-icon
    svgIcon="image__button-fullscreen"
    role="button"
    tabindex="0"
    (click)="fullscreenService.openFullscreen(target, $event)"
    (keyup.enter)="fullscreenService.openFullscreen(target, $event)"
    (keyup.space)="fullscreenService.openFullscreen(target, $event)"
    [matTooltip]="'activities.lesson.display' | translate"
    [attr.aria-describedby]="'accessibility.zoomable_info' | translate"
    [attr.aria-label]="'accessibility.zoomable_info_aria_label'| translate">
  </mat-icon>
}